import React from 'react';
import { Grid, Header, Icon, Popup } from 'semantic-ui-react';
import type { RidershipFiscalPipelineStatus, RidershipReadinessReportStatusLevel } from '../../../types/ridershipReadinessTypes';
import { getCurrentFyReportingScope, isFiscalMonthExcluded } from './reportingScope';

const iconName: Record<RidershipReadinessReportStatusLevel, 'check circle' | 'warning sign' | 'times circle'> = {
    Ready: 'check circle',
    Attention: 'warning sign',
    Unavailable: 'times circle',
};

const iconColor: Record<RidershipReadinessReportStatusLevel, 'green' | 'orange' | 'red'> = {
    Ready: 'green',
    Attention: 'orange',
    Unavailable: 'red',
};

interface Props {
    fiscal: RidershipFiscalPipelineStatus;
    fiscalYear: number;
    timeZoneName: string;
}

const FiscalMonthGrid: React.FC<Props> = ({ fiscal, fiscalYear, timeZoneName }) => {
    const scope = getCurrentFyReportingScope(fiscalYear, timeZoneName);
    const visibleMonths = fiscal.months.filter(
        month => !scope.applies || !isFiscalMonthExcluded(month.monthName, scope.excludedMonthName),
    );

    return (
        <div>
            <Header as="h3">Fiscal year monthly files (FY{fiscal.fiscalYear})</Header>
            <p style={{ color: 'rgba(0,0,0,.7)' }}>
                METRO monthly CSVs feed the Boarding Summary year-over-year and timeline charts.
            </p>
            {scope.applies && (
                <p style={{ color: 'rgba(0,0,0,.6)', fontSize: '0.95em' }}>
                    The current calendar month is hidden until monthly files are reported.
                </p>
            )}
            <Grid columns={4} stackable>
                {visibleMonths.map(month => (
                    <Grid.Column key={month.monthName}>
                        <Popup
                            content={`Blob complete: ${month.blobComplete ? 'yes' : 'no'}; Delta total: ${month.deltaHasTotal ? 'yes' : 'no'}; Delta average: ${month.deltaHasAverage ? 'yes' : 'no'}${month.selectedBlobFolderPath ? `; Folder: ${month.selectedBlobFolderPath.split('/').join(' > ')}` : ''}`}
                            trigger={(
                                <div style={{ textAlign: 'center', padding: '0.5rem' }}>
                                    <Icon name={iconName[month.status]} color={iconColor[month.status]} size="large" />
                                    <div>{month.monthName}</div>
                                </div>
                            )}
                        />
                    </Grid.Column>
                ))}
            </Grid>
        </div>
    );
};

export default FiscalMonthGrid;
